<template>
  <v-card>
    <v-card-title primary-title>
      <div class="headline">
        Documents
      </div>
    </v-card-title>

    <v-container
      grid-list-xl
      fluid
    >
      <v-layout
        row
        wrap
      >
        <v-flex
          v-for="doc in documents"
          :key="doc.id"
          xs4
        >
          <v-card
            flat
            tile
            class="document-tile"
            @click="showDocumentsEditor(doc)"
          >
            <v-icon x-large>
              insert_drive_file
            </v-icon>
            <div>{{ doc.title }}</div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-card-actions>
      <v-btn
        class="flex-grow-1"
        outlined
        color="primary"
        @click="showDocumentsEditor({})"
      >
        Create
      </v-btn>

      <v-btn
        v-if="integrations && integrations.google_drive"
        class="flex-grow-1"
        outlined
        color="primary"
        @click="loadPicker"
      >
        <v-icon left>
          cloud_queue
        </v-icon>
        From cloud
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex'

import firestore from '@/database'
import { loadGAPI } from '@/utils/gapi'

export default {
  props: {
    project: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      documents: []
    }
  },
  computed: {
    ...mapState('user', [ 'integrations' ])
  },
  mounted () {
    this.loading = true

    firestore.collection('attachments')
      .where('project', '==', this.project.id)
      .orderBy('updatedAt', 'desc')
      .limit(10)
      .onSnapshot(querySnapshot => {
        this.documents = []

        querySnapshot.forEach(doc => {
          const x = doc.data()
          Object.defineProperty(x, 'id', { value: doc.id, enumerable: false })
          this.documents.push(x)
        })

        this.loading = false
      }, err => {
        this.$notifyError('Can\'t get recent documents', err)
      })
  },
  methods: {
    ...mapActions('user', [ 'getAuthToken' ]),
    ...mapMutations('documents', [ 'showDocumentsEditor' ]),
    loadPicker () {
      loadGAPI().then(gapi => {
        gapi.load('picker', { callback: this.createPicker })
      })
    },
    async createPicker () {
      const authToken = await this.getAuthToken('google_drive')

      if (!authToken) {
        return
      }

      /* global google */
      const view = new google.picker.View(google.picker.ViewId.DOCS)

      const picker = new google.picker.PickerBuilder()
        .enableFeature(google.picker.Feature.NAV_HIDDEN)
        .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
        .setAppId('713781402583')
        .setOAuthToken(authToken)
        .addView(view)
        .addView(new google.picker.DocsUploadView())
        .setDeveloperKey('AIzaSyDzyTCzJCIdio9rTiF9XFwR04kjZY3ZXng')
        .setCallback(this.pickerCallback)
        .build()
      picker.setVisible(true)
    },
    pickerCallback (data) {
      if (data.action === google.picker.Action.PICKED) { }
    }
  }
}
</script>

<style lang="scss">
.document-tile {
  cursor: pointer;
  text-align: center;
}
</style>
